import * as types from './index';

export const patientFormSubmitAction = (patient) => {
  return {
    type: types.PATIENT_SUBMIT,
    patient
  }
};